import { useEffect, useState } from 'react';
import { TelegramSticker } from '@/components/TelegramSticker';
import styles from './AppLoader.module.scss';
import usePreloadStore from '@/store/PreloadStore';
import PreloadCheck from '@/features/PreloadCheck';

interface AppLoaderProps {
  children: React.ReactNode;
}

export const AppLoader = ({ children }: AppLoaderProps) => {
  const [progress, setProgress] = useState(0);
  const preloaded = usePreloadStore((state) => state.preloaded);


  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prevProgress + 1;
      });
    }, 10);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <PreloadCheck />
      {!preloaded ? (
        <div className={styles.loader}>
          <div className={styles.loader__content}>
            <TelegramSticker
              tgsUrl="../../public/AnimatedSticker.tgs"
              style={{ width: 200, height: 200 }}
              loop={true}
              autoplay={true}
            />
            <div className={styles.loader__text}>
              Загрузка приложения... {progress}%
            </div>
            <div className={styles.loader__progress}>
              <div
                className={styles.loader__progressBar}
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};
